<template>
  <el-dialog
    v-show="isInit"
    :visible="visible"
    width="800px"
    class="face-box"
    @close="close"
  >
    <div id="faceContainer"></div>
  </el-dialog>
</template>

<script>
import { faceInit, faceResult } from '@/api/apis/auth';
import { clstagA } from '@/utils/index';

let initNums = 0;
export default {
  name: 'FaceRecognition',
  components: {
  },
  props: {
    visible: Boolean,
    idCardData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isInit: false,
      loading: true,
      faceInfo: {
        authNo: null, // 认证编号
        url: null, // 认证组件配置url
      },
      unifiedAuthEntry: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      initNums = 0;
      this.init();
    });
  },
  methods: {
    // 初始化人脸识别内容
    init() {
      if (initNums > 2) {
        this.close();
        return;
      }
      initNums++;
      this.unifiedAuthEntry = new window.UnifiedAuthEntry('#faceContainer');
      this.getFaceInfo();
    },
    // 登录
    login() {
      const PASSPORT = 'https://passport.shop.jd.com/login/index.action/jdm?source=jmqy11&ReturnUrl=';
      const ReturnUrl = (window.location.href.indexOf('401') !== -1 || window.location.href.indexOf('regist') !== -1) ? window.location.origin : window.location.href;
      window.location.href = PASSPORT + encodeURIComponent(ReturnUrl);
    },
    // 查询认证结果
    async getFaceRes() {
      const { authNo } = this.faceInfo;
      const res = await faceResult({ authNo });
      const {
        // eslint-disable-next-line no-unused-vars
        code, data, message, subErrors,
      } = res;
      if (code === 200) {
        // 认证状态：1:未知, 2: 成功, 3: 失败
        const { status } = data;
        if (status === '2') {
          this.close(authNo);
        } else {
          this.$message.error('鉴权失败，请重新进行鉴权');
          if (this.unifiedAuthEntry?.entryConfig?.url) {
            this.unifiedAuthEntry.destroy();
            this.unifiedAuthEntry = null;
          }
          this.init();
        }
      } else {
        this.$message.error('获取鉴权结果失败，请重新进行鉴权！');
        if (this.unifiedAuthEntry?.entryConfig?.url) {
          this.unifiedAuthEntry.destroy();
          this.unifiedAuthEntry = null;
        }
        this.init();
      }
    },
    // 获取人脸识别url
    async getFaceInfo() {
      this.loading = true;
      const params = {
        idCard: this.idCardData?.cardNo,
        name: this.idCardData?.name,
      };
      const res = await faceInit(params);
      const {
        // eslint-disable-next-line no-unused-vars
        code, data, message, subErrors,
      } = res;
      if (code === 200) {
        // 增加人脸识别开关
        if (typeof data.isCheck !== 'undefined' && Number(data.isCheck) === 0) {
          this.close(true);
        } else {
          this.faceInfo = data;
          this.isInit = true;
          const self = this;
          // 配置要显示的鉴权页面
          this.unifiedAuthEntry.config({
            url: self.faceInfo.url,
            finish(resCode) {
              self.unifiedAuthEntry.destroy();
              self.unifiedAuthEntry = null;
              self.getFaceRes(resCode);
            },
            // 鉴权过程出现异常情况的回调
            error(errorCode) {
            // 用户点击取消
              if (errorCode === 'E00003') {
                self.close();
              } else if (errorCode === 'E00001') { // 未登录
                self.login();
              } else {
              // 'E00002' 超时（包含情况：鉴权链接已超时、鉴权流程已完成重复进入、组件流程已结束重复进入）
              // 'E00003' 可重新发起新的鉴权流程或者引导用户联系客服
                self.$message.error('鉴权异常，请重新进行鉴权');
                if (self.unifiedAuthEntry?.entryConfig?.url) {
                  self.unifiedAuthEntry.destroy();
                  self.unifiedAuthEntry = null;
                }
                self.init();
              }
            },
          });

          // 显示鉴权页面
          this.unifiedAuthEntry.show();
          this.loading = false;
          clstagA('pageclick|keycount|info_legalAuth|faceAuth');

        // setTimeout(() => { this.unifiedAuthEntry.show(); }, 2000);
        }
      } else {
        this.close();
        this.$message.error(message || '获取鉴权地址失败，请稍后重试');
      }
    },
    // 取消上传
    close(authNo = null) {
      this.faceInfo = {};
      this.$emit('close', authNo);
      clstagA('pageclick|keycount|info_legalAuth|faceAuth_cancel');
      if (this.unifiedAuthEntry?.entryConfig?.url) {
        this.unifiedAuthEntry.destroy();
        this.unifiedAuthEntry = null;
      }
    },
    destroyed() {
      initNums = 0;
    },
  },
};
</script>

<style lang="scss">
@import '../../../assets/style/info/UnifiedAuthLayer.3.0.0.css';
.face-box .el-dialog__body{
  margin: 0;
  padding: 0;
}
.el-tooltip__popper {
  box-sizing: unset;
}
</style>
